<template>
  <div class="list errCheck">
    <div class="auctionRegister">
      <h1 class="topTitle">エラー確認</h1>
      <!-- <button @click="test">test</button> -->
      <div class="container">
        
        <div class="item-wrap">
          <div
            v-for="(item, index) in tmpErrList"
            :key="index"
            v-show="item.display"
          >
            <div
              class="titleVal majorItems"
              :class="{ isOpen: item.childOpen, isClose: !item.childOpen }"
              @click="item.childOpen = !item.childOpen"
            >
            <span>出品媒体：{{ item.SITE_TYPE == "m"? "メルカリ":item.SITE_TYPE == "r"? "ラクマ":"ヤフオク"}}</span>
            <span>::出品日{{item.ERR_DATE}}</span>
              <br><span>ユーザー名：{{ item.USER_NAME }}</span>
              <span>（商品名：{{ item.ITEM_TITLE }}）</span>
            </div>
            <div v-show="item.childOpen">
              <button class="btn" @click="delErr(item)">画像を削除する</button>
              <a @click="setImg(item.ERR_IMAGE)" href="#">
                <img width="50%" :src="item.ERR_IMAGE" />
              </a>
            </div>
          </div>
        </div>
        <div id="overlay" v-show="isShowImg">
          <div class="imgModal">
            <div class="swal2-popup swal2-modal swal2-show">
              
              
            </div>
            <img width="100%" class="itemImg" :src="showImg" />
            
            <button
              class="swal2-confirm swal2-styled"
              @click="isShowImg = false"
            >
              戻る
            </button>
          </div>
        </div>
      </div>
      <div class="btnBox subArea">
        <button class="btn repage" @click="returnPage">戻る</button>
        <!-- <button class="btn submit" @click="register" :disabled="isDisabled" >登録する</button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { errRepository } from "@/Repositories/errRepository.js";

import VueJsPaginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";
import moment from "moment";
export default {
  data() {
    return {
      /******************
       * Datepicker設定
       ******************/
      ja: ja,
      disabledDates: {
        from: new Date(),
      },
      /******************
       * 表示フラグ
       ******************/
      isShowSerchBox: false,
      isDisabled: true,
      isModal: false,
      isShowImg: false,
      showImg:'',

      /******************
       * ユーザー情報
       ******************/
      userInfo: {},
      userList: [],
      setUserId: "",
      tmpSiteType: null,
      /******************
       * エラー情報
       ******************/
      errList: [{ childOpen: false }],
      tmpErrList: [{ childOpen: false }],
    };
  },
  components: {
    "vuejs-paginate": VueJsPaginate,
    Datepicker,
  },
  methods: {
    returnPage() {
      let vm = this;
      vm.$router.back();
    },

    setImg(img) {
      this.showImg = img;
      this.isShowImg = true;
    },
    modal(sellId) {
      let vm = this;
      vm.tmpComList = [];
      this.comList.filter((val) => {
        if (val.SELL_ID == sellId) {
          var v = val.COMMENT.split(";");
          vm.tmpComList.push({ name: v[0], comment: v[1] });
        }
      });
      vm.isModal = true;
      vm.tmpSellId = sellId;
    },
    delErr(err){
      let vm = this;
      errRepository.methods.delete(err)
      .then(res=>{
        vm.$functions.swNgAlert(vm,"success", "削除しました。","")
        .then(res=>vm.$functions.reload(vm));
      })
      .catch(err=>{
        console.log(err);
        vm.$functions.swNgAlert(vm,"error", "削除に失敗しました。","")
        })
    }
  },
  computed: {
    
  },
  created: async function () {
    let vm = this;
    // await vm.init();

    errRepository.methods
      .getAll()
      .then((res) => {

        var data = res.data;
        for (var i = 0; i < data.length; i++) {
          data[i].ERR_IMAGE = "data:image/jpeg;base64, " + data[i].ERR_IMAGE;
          data[i].display = true;
          data[i].childOpen = false;
        }
        vm.errList = data;
        vm.tmpErrList = data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss">
@import "../style/errCheck.scss";
@import "../style/auctionRegister.scss";
</style>